<template lang="pug">
div.input
    label.tech.grey {{ label }}
    input.input-field(:value="value" @input="updateValue($event.target.value)" :placeholder="placeholder")
</template>

<script>
import Input from './Input.vue';
export default {
    name: 'text-input',
    extends: Input
}
</script>
